import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=45910624&scoped=true"
import script from "./date-input.vue?vue&type=script&lang=js"
export * from "./date-input.vue?vue&type=script&lang=js"
import style0 from "./date-input.vue?vue&type=style&index=0&id=45910624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45910624",
  null
  
)

export default component.exports